export default __webpack_public_path__ + "static/media/crazyPets_DP.410cae93.png";